import React, { Component, useEffect, useState, useRef } from 'react';
import { Collapse, CardBody, Card, CardHeader } from 'reactstrap';
import './event.css';

class EventPreview extends Component {
  constructor(props) {
    super(props);
    this.state = {
      event: [],
      collapse: -1,
    };
  }
  componentDidMount() {

  }
  toggle(event) {
    this.setState({
      collapse: this.state.collapse === (event) ? -1 : (event)
    });
  }
  componentWillReceiveProps(nextProps) {
    console.log('nextProps', nextProps);
    if (nextProps.eData) {
      this.setState({
        event: nextProps.eData
      })
    }
  }
  render() {
    const { event, collapse } = this.state;
    const { registration_details, page_css, speaker_details, faq_details } = event;
    var btnCss = page_css ? page_css.btn_css : [];
    var form_css = page_css ? page_css.form_css : [];
    console.log('speaker_details', event);
    return (
      <React.Fragment>
        <style>
          {btnCss &&
            `  a.com-event-reg-btn{
                            background-color: ${btnCss.btn_bg_clr} !important;
                            color:${btnCss.btn_font_clr} !important;
                        }
                        a.com-event-reg-btn:hover{
                            background-color: ${btnCss.btn_hvr_bg_clr} !important;
                            border-color: ${btnCss.btn_hvr_bdr_clr} !important;
                            color: ${btnCss.btn_hvr_font_clr} !important;
                            text-decoration: none;
                        }
                  `}
          {form_css &&
            `  .bevents-container .event-reg-title p{
                            color:${form_css.form_title_clr} !important;
                            text-transform: capitalize;
                        }
                        .bevents-container .event-reg{
                            background-color: ${form_css.form_bg_clr} !important;
                            color: ${form_css.form_bg_clr} !important;
                        }
                        .bevents-container .event-reg .event-resgiter-btn{
                            background-color: ${form_css.sb_btn_bg_clr} !important;
                            color: ${form_css.sb_btn_font_clr} !important;
                            border-color: ${form_css.sb_btn_bg_clr} !important;
                            font-weight: 600;
                        }
                `}
        </style>
        <div className='tranparent-header-custom-inner'>
          <div className='container-fluid'>
            <div className='row align-items-center header-custom'>
              <div className='col-lg-10 col-md-6 col-12'>
                <div className='bewise-logo active'>
                  <div class="row">
                    <div>
                      <a className='logo-text' href='/' target='_blank'>
                        <img src={'/assets/images/bewiselogo.png'} style={{ width: "130px", marginRight: "2px" }} />
                      </a>
                    </div>
                  </div>
                </div>
              </div>
              {registration_details && registration_details.isForm && (
                <div className='col-lg-2 col-md-6 text-right mobile-position event-header-cus'>

                  <a href='javascript:;' className="btn btn-lg com-event-reg-btn">
                    Register
                  </a>
                </div>
              )}

            </div>
          </div>
        </div>
        <section className=''>
          <div className='event-com-ban-sec'>
            <div className='row'>
              <div className='col-md-12 com-banner'>
                {(event.tempBanner || event.c_banner_image) && (
                  <img src={event.tempBanner ? event.tempBanner : event.c_banner_image} alt='Event Banner'
                    height={468} />
                )}
              </div>
            </div>
          </div>
        </section>
        <section class="container p-0" style={{ width: '100%' }}>
          <div className='bevents-page'>
            <div className='bevents-container'>
              <div className='row'>
                <div
                  className={registration_details && registration_details.isForm ? 'col-md-8' : 'col-md-12'}>
                  <div className='row'>
                    <div className='col-md-12'>
                      <h3><b>
                        {event.event_title}
                      </b></h3>
                      <div className=''
                        dangerouslySetInnerHTML={{ __html: event.event_content }}></div>

                    </div>
                  </div>
                </div>
                {registration_details && registration_details.isForm && (
                  <div className='col-md-4'>
                    <div className='event-reg'>
                      <div className='event-reg-container'>
                        <div className='col-md-12'>
                          <div className='col-md-12 event-reg-title'>
                            <p>{form_css.form_title}</p>
                          </div>
                          <div className='event-reg-form'>
                            <form onSubmit={() => { alert('This is preview Form') }} autoComplete='off'>
                              {registration_details.form.map((item, i) => {
                                let condition = item.input_type == 'email' ? 'required|emailExist_check' : 'required';
                                console.log('condition', condition);
                                return (
                                  <React.Fragment>
                                    <div className='col-md-12' style={{ marginBottom: '48px' }}>
                                      {item.input_type == 'file' ? (
                                        <input type={item.input_type} placeholder={item.lbl_name}
                                          className={'cus-file-field form-control'} name={item.input_name}
                                          onChange={(e) => this.handleFile(e, item.max_upload)}
                                          multiple={true} />
                                      ) :
                                        (
                                          <input type={item.input_type} placeholder={item.lbl_name}
                                            className={'form-control'} name={item.input_name}
                                            onChange={this.handleChange}
                                            value={this.state[item.input_name]} />
                                        )}
                                    </div>
                                  </React.Fragment>
                                )
                              })}
                              <div className='col-md-12'>
                                <button className='btn btn-sm btn-secondary event-resgiter-btn'
                                  disabled>Submit</button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className='col-md-12' style={{ marginTop: '32px', padding: '0' }}>
                      <p>
                        Please cross-check your SPAM mailbox, just in case our
                        invite is not on your primary mailbox.
                      </p>
                    </div>
                  </div>
                )}
              </div>
              {speaker_details && speaker_details.length > 0 && (
                <React.Fragment>

                  <div className='row'>
                    <div className='col-md-12'>
                      <h3>Know about our keynote speaker:</h3>
                    </div>
                  </div>
                  <div className='row'>
                    {speaker_details.map((item, i) => {
                      return (
                        <div className='col-md-12'>
                          <h4>{item.spk_title ? item.spk_title : ''} {item.spk_name}</h4>
                          <div>
                            <p>
                              <img src={item.temp_img ? item.temp_img : event.img_url + item.spk_img}
                                alt={`Image of ${item.spk_name}`} width={'200px'}
                                style={{ float: 'left', paddingRight: '15px' }} />
                            </p>
                            <p className='text-justify'
                              dangerouslySetInnerHTML={{ __html: item.spk_desc }}>
                            </p>
                          </div>
                        </div>
                      )
                    })}
                  </div>
                </React.Fragment>
              )}
              <h3>FAQ’s </h3>
              {faq_details && (
                <Card className='panel-group custom-card' style={{ marginBottom: '1rem' }}>
                  {faq_details.map((item, index) => {
                    return (
                      <React.Fragment>
                        <CardHeader onClick={() => this.toggle(`f-${index}`)} data-event={`f-${index}`} className='custom-card-heading'>
                          <b>{item.ques} </b>
                          {collapse !== `f-${index}` ? (
                            <span className='pull-right'>
                              <i class="fa fa-plus" aria-hidden="true"></i>
                            </span>
                          ) : (
                            <span className='pull-right'>
                              <i class="fa fa-minus" aria-hidden="true"></i>
                            </span>
                          )}
                        </CardHeader>
                        <Collapse isOpen={collapse === `f-${index}`}>
                          <CardBody className='panel-body'>
                            <p dangerouslySetInnerHTML={{ __html: item.ans }}></p>
                          </CardBody>
                        </Collapse>

                      </React.Fragment>
                    )
                  })}
                </Card>
              )}
              <p>
                BeWise is a one–stop platform that enables parents make easy,
                informed and efficient choices about the pre-school, school,
                and after-school institutions and individuals they want their
                children to be associated with, with access to deep information,
                reviews and ratings. To know more about us, <a href='/' target='_blank'><b>click here</b></a>
              </p>
            </div>
          </div>
        </section>
      </React.Fragment>
    );

  }
}
export default EventPreview;


// WEBPACK FOOTER //
// ./src/components/bewise/event_preview.jsx